module.exports = __webpack_public_path__ + "media/images/calendar-icon-7fa821da8eedbbe38415e3d645b7347d.svg";